import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import * as workerTimers from "worker-timers";
import "./timer.css";
import Authapi from "../../Services/Authapi";
import config from "../../../Config";
import swal from 'sweetalert';
import PremiumButton from "../../Layouts/PremiumButton";
import { toast } from 'react-toastify';
import {
  clearAttendanceExtensionState,
  notifyAttendanceExtensionPageAutoOutCompleted,
  pingAttendanceExtension,
  subscribeToAttendanceExtensionEvents,
  syncAttendanceExtensionState,
} from "../../../utils/attendanceExtension";

const EXTENSION_IDLE_MINUTES = 5;
const EXTENSION_REASON = "at_work";
const EXTENSION_TOAST_ID = "attendance-extension-auto-out";
const EXTENSION_SYNC_INTERVAL_MS = 10000;
const AUTO_TIMER_OFF_MINUTES_STORAGE_KEY = "hrmsAutoTimerOffMinutes";
const AUTO_TIMER_OFF_REASON_KEY = "hrmsAutoTimerOffReason";

class Timer extends Component {
  constructor(props) {

    super(props);
    this.state = {
      timer: 0,
      totaltimer: 0,
      isActive: false,
      isPaused: false,
      startTime: 0,
      stopTime: 0,
      isLoading: false,
      isInitialLoading: true,
      extensionConnected: false,
      extensionWarningMessage: "",
      extensionDebugStatus: "Waiting for extension activity...",
      extensionDebugTime: "",
    };
    this.countRef = React.createRef(null);
    this.totalCountRef = React.createRef(null);
    this.unsubscribeFromExtension = null;
    this.lastExtensionAutoOutAt = null;
    this.lastPageAutoOutRequestAt = null;
    this.boundHandleComponentUnmount = this.handleComponentUnmount.bind(this);
    this.handleAutoTimerMinutesUpdated = this.handleAutoTimerMinutesUpdated.bind(this);
    this.handleAutoTimerReasonUpdated = this.handleAutoTimerReasonUpdated.bind(this);
  }

  async componentDidMount() {
    // console.log(this.props.user.Notification_Status);
    //     if (this.props.user.Notification_Status === 1) {
    //       setInterval(() => {
    //         this.breaktimeremainder()
    //       }, 300000)  // 5 minit 
    //     }

    // Check duration and auth status independently to ensure no blocking
    // Check duration first and wait for it to complete to establish 'isActive' state
    await this.checkDuration();
    this.unsubscribeFromExtension = subscribeToAttendanceExtensionEvents(this.handleExtensionEvent);
    pingAttendanceExtension();
    await this.syncExtensionState();
    this.setupBreakNotification();
    this.checkTotalTimer();
    this.startExtensionStatusSync();
    window.addEventListener("auto-timer-off-settings-updated", this.handleAutoTimerMinutesUpdated);
    window.addEventListener("auto-timer-off-reason-updated", this.handleAutoTimerReasonUpdated);

    this.taskDeadlineInterval = setInterval(async () => {
      try {
        await Authapi.notifyTasksDeadlinePassed();
      } catch (error) {
        console.error("Error notifying task deadlines:", error);
      }
    }, 120000); // 120000 milliseconds = 2 minutes

    window.addEventListener("beforeunload", this.boundHandleComponentUnmount);
  }

  checkDuration = async () => {
    try {
      let timeCount = await Authapi.durTime(this.props.user.id);
      const totalDurationInSec = parseInt(timeCount.totalDurationInSec, 10);

      if (totalDurationInSec > 0) {
        this.setState({ timer: totalDurationInSec, isActive: true, isInitialLoading: false }, async () => {
          this.runCycle();
          await this.syncExtensionState({ isTimerActive: true });
        });
      } else {
        this.setState({ timer: 0, isActive: false, isInitialLoading: false }, async () => {
          await this.syncExtensionState({ isTimerActive: false });
        });
      }
    } catch (error) {
      console.error("Error fetching duration time:", error);
      this.setState({ isInitialLoading: false });
    }
  }

  setupBreakNotification = async () => {
    try {
      const authResponse = await Authapi.checkAuth(this.props.user.id);
      if (authResponse && authResponse.data && authResponse.data.user && authResponse.data.user.Break_notification_status === 1) {
        // Clear any existing interval just in case
        if (this.breakTimerInterval) clearInterval(this.breakTimerInterval);

        this.breakTimerInterval = setInterval(() => {
          this.breaktimeremainder();
        }, 300000);  // Check every 5 minutes
        this.breaktimeremainder();
      }
    } catch (error) {
      console.error("Error checking auth status:", error);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.boundHandleComponentUnmount);
    workerTimers.clearInterval(this.countRef.current);
    workerTimers.clearInterval(this.totalCountRef.current);
    clearInterval(this.taskDeadlineInterval);
    clearInterval(this.breakTimerInterval);
    workerTimers.clearInterval(this.extensionSyncInterval);
    window.removeEventListener("auto-timer-off-settings-updated", this.handleAutoTimerMinutesUpdated);
    window.removeEventListener("auto-timer-off-reason-updated", this.handleAutoTimerReasonUpdated);
    if (this.unsubscribeFromExtension) {
      this.unsubscribeFromExtension();
      this.unsubscribeFromExtension = null;
    }
  }

  handleComponentUnmount() {
    if (this.state.isActive) {
      Authapi.saveTime(this.state.timer);
    }
  }

  async checkTotalTimer() {
    try {
      let timeCount = await Authapi.dureTime1(this.props.user.id);

      const totalDurationInSec = parseInt(timeCount.totalDurationInSec, 10);

      if (totalDurationInSec > 0) {
        this.setState({ totaltimer: totalDurationInSec }, this.runCycle1);
      } else {
        // this.setState({ isInitialLoading: false });
      }
    } catch (error) {
      console.error("Error fetching duration time:", error);
      // this.setState({ isInitialLoading: false });
    }
  }

  breaktimeremainder = async () => {
    if (!this.state.isActive) {
      const result = await Authapi.breaktimeremainder();

      if (result.status === true) {
        if (Notification.permission === "default") {
          Notification.requestPermission().then(permission => {
            if (permission === "granted") {
              new Notification("Notification", {
                body: result.message,
                icon: "/logo.png",
              });
            }
          });
        } else if (Notification.permission === "granted") {
          new Notification("Notification", {
            body: result.message,
            icon: "/logo.png",
          });
        }
      }
    } else {

    }
  };



  runCycle() {
    workerTimers.clearInterval(this.countRef.current);
    this.countRef.current = workerTimers.setInterval(() => {
      this.setState((prevState) => ({ timer: prevState.timer + 1 }));
    }, 1000);
  }

  runCycle1() {
    if (this.state.isActive === true) {
      workerTimers.clearInterval(this.totalCountRef.current);
      this.totalCountRef.current = workerTimers.setInterval(() => {
        this.setState((prevState) => ({ totaltimer: prevState.totaltimer + 1 }));
      }, 1000);
    }
  }

  getExtensionPayload = (overrides = {}) => {
    const authToken = window.localStorage.getItem("authToken") || "";
    const configuredMinutesRaw = Number(
      window.localStorage.getItem(AUTO_TIMER_OFF_MINUTES_STORAGE_KEY) || EXTENSION_IDLE_MINUTES
    );
    const configuredMinutes = Number.isFinite(configuredMinutesRaw) && configuredMinutesRaw > 0
      ? configuredMinutesRaw
      : EXTENSION_IDLE_MINUTES;
    const configuredReason = window.localStorage.getItem(AUTO_TIMER_OFF_REASON_KEY) || EXTENSION_REASON;

    return {
      token: authToken,
      userId: this.props.user?.id ? String(this.props.user.id) : "",
      isTimerActive: overrides.isTimerActive ?? this.state.isActive,
      autoTimerOffMinutes: overrides.autoTimerOffMinutes ?? configuredMinutes,
      reason: overrides.reason ?? configuredReason,
      apiUrl: overrides.apiUrl ?? config.apiurl,
    };
  };

  syncExtensionState = async (overrides = {}) => {
    const posted = syncAttendanceExtensionState(this.getExtensionPayload(overrides));
    if (!posted) {
      this.setState({ extensionConnected: false });
    }
  };

  handleAutoTimerMinutesUpdated = async (event) => {
    const minutesFromEvent = Number(event?.detail?.autoTimerOffMinutes);
    const normalizedMinutes = Number.isFinite(minutesFromEvent) && minutesFromEvent > 0
      ? minutesFromEvent
      : EXTENSION_IDLE_MINUTES;

    await this.syncExtensionState({ autoTimerOffMinutes: normalizedMinutes });
  };

  handleAutoTimerReasonUpdated = async (event) => {
    const nextReason = event?.detail?.reason === "in_meeting" ? "in_meeting" : EXTENSION_REASON;
    await this.syncExtensionState({ reason: nextReason });
  };

  clearExtensionState = () => {
    clearAttendanceExtensionState({
      userId: this.props.user?.id ? String(this.props.user.id) : "",
      apiUrl: config.apiurl,
    });
  };

  handlePageAutoOutRequest = async (payload) => {
    const currentUserId = this.props.user?.id ? String(this.props.user.id) : "";
    if (!currentUserId || payload.userId !== currentUserId || !this.state.isActive) {
      return;
    }

    const requestTimestamp = payload.requestedAt || Date.now();
    if (this.lastPageAutoOutRequestAt === requestTimestamp) {
      return;
    }

    this.lastPageAutoOutRequestAt = requestTimestamp;
    console.info("[HRMS Extension Debug] page_auto_out_requested", payload);
    this.setState({
      extensionDebugStatus: payload.failureReason
        ? `Page fallback auto out requested | ${payload.failureReason}`
        : "Page fallback auto out requested",
      extensionDebugTime: new Date(requestTimestamp).toLocaleTimeString(),
    });

    try {
      await Authapi.outTime();
      notifyAttendanceExtensionPageAutoOutCompleted({
        userId: currentUserId,
        reason: payload.reason || "idle",
        requestedAt: requestTimestamp,
      });
    } catch (error) {
      console.error("Error completing auto timer off from page fallback:", error);
    }
  };

  handleExtensionEvent = async (payload) => {
    if (!payload || !payload.type) {
      return;
    }

    if (payload.type === "pong") {
      console.info("[HRMS Extension Debug] pong", payload);
      this.setState({
        extensionConnected: true,
        extensionWarningMessage: "",
        extensionDebugStatus: "Extension responded to ping.",
        extensionDebugTime: new Date().toLocaleTimeString(),
      });
      return;
    }

    if (payload.type === "state_synced") {
      console.info("[HRMS Extension Debug] state_synced", payload);
      this.setState({
        extensionConnected: !!payload.connected,
        extensionWarningMessage: payload.connected ? "" : this.state.extensionWarningMessage,
        extensionDebugStatus: payload.connected
          ? "Timer state synced to extension."
          : this.state.extensionDebugStatus,
        extensionDebugTime: payload.connected ? new Date().toLocaleTimeString() : this.state.extensionDebugTime,
      });
      return;
    }

    if (payload.type === "debug_status") {
      console.info("[HRMS Extension Debug] debug_status", payload);
      const nextStatus = payload.stage
        ? `${String(payload.stage).replace(/_/g, " ")}`
        : "Debug update received";
      const nextDetails = payload.details && typeof payload.details === "object"
        ? Object.entries(payload.details)
          .filter(([, value]) => value !== undefined && value !== null && value !== "")
          .map(([key, value]) => `${key}: ${value}`)
          .join(" | ")
        : "";

      this.setState({
        extensionConnected: true,
        extensionDebugStatus: nextDetails ? `${nextStatus} | ${nextDetails}` : nextStatus,
        extensionDebugTime: payload.timeLabel || "",
      });
      return;
    }

    if (payload.type === "context_invalidated") {
      console.warn("[HRMS Extension Debug] context_invalidated", payload);
      this.setState({
        extensionConnected: false,
        extensionWarningMessage: payload.message || "Extension updated. Please refresh the page.",
        extensionDebugStatus: payload.message || "Extension context invalidated.",
        extensionDebugTime: "",
      });
      return;
    }

    if (payload.type === "request_page_auto_out") {
      await this.handlePageAutoOutRequest(payload);
      return;
    }

    if (payload.type !== "auto_out") {
      return;
    }
    console.info("[HRMS Extension Debug] auto_out", payload);

    const currentUserId = this.props.user?.id ? String(this.props.user.id) : "";
    if (!currentUserId || payload.userId !== currentUserId) {
      return;
    }

    if (payload.happenedAt && payload.happenedAt === this.lastExtensionAutoOutAt) {
      return;
    }

    this.lastExtensionAutoOutAt = payload.happenedAt || Date.now();

    workerTimers.clearInterval(this.countRef.current);
    workerTimers.clearInterval(this.totalCountRef.current);

    this.setState({
      isActive: false,
      isLoading: false,
      stopTime: Date.now(),
      extensionConnected: true,
      extensionWarningMessage: "",
      extensionDebugStatus: payload.message || "Timer auto stopped due to inactivity.",
      extensionDebugTime: payload.happenedAt
        ? new Date(payload.happenedAt).toLocaleTimeString()
        : "",
    });

    toast.dismiss(EXTENSION_TOAST_ID);
    toast.error(payload.message || "Timer auto stopped due to inactivity.", {
      toastId: EXTENSION_TOAST_ID,
      autoClose: 2500,
      pauseOnFocusLoss: false,
    });

    await this.checkDuration();
    await this.checkTotalTimer();
  };

  startExtensionStatusSync = () => {
    workerTimers.clearInterval(this.extensionSyncInterval);
    this.extensionSyncInterval = workerTimers.setInterval(async () => {
      await this.checkServerTimerStopped();
      await this.syncExtensionState();
    }, EXTENSION_SYNC_INTERVAL_MS);
  };

  checkServerTimerStopped = async () => {
    if (!this.state.isActive || !this.props.user?.id) {
      return;
    }

    try {
      const timeCount = await Authapi.durTime(this.props.user.id);
      const totalDurationInSec = parseInt(timeCount?.totalDurationInSec, 10);

      if (totalDurationInSec > 0) {
        return;
      }

      workerTimers.clearInterval(this.countRef.current);
      workerTimers.clearInterval(this.totalCountRef.current);

      this.setState({
        isActive: false,
        timer: 0,
        stopTime: Date.now(),
      });

      await this.syncExtensionState({ isTimerActive: false });
      await this.checkTotalTimer();
    } catch (error) {
      console.error("Error checking timer state after extension sync:", error);
    }
  };

  handleStart = async () => {
    this.setState({ isLoading: true });
    await new Promise(resolve => setTimeout(resolve, 2000));

    try {
      await Authapi.inTime();
      this.setState({
        isActive: true,
        startTime: Date.now(),
        isLoading: false,
        stopTime: 0,
      }, async () => {
        this.runCycle();
        this.runCycle1();
        await this.syncExtensionState({ isTimerActive: true });
      });

      toast.success("You marked IN");

    } catch (error) {
      this.setState({ isLoading: false });
      const responseData = error.response?.data;
      const errorMessage = responseData?.message || "An error occurred while clocking in.";

      // Attempt to extract detailed information
      let pendingLeaves = responseData?.pending_leaves || [];
      let totalDays = responseData?.total_pending_days || responseData?.pending_count || (Array.isArray(pendingLeaves) ? pendingLeaves.length : 0);
      let fromDate = responseData?.from_date;
      let toDate = responseData?.to_date;

      // Handle cases where information might be in the errorMessage but not explicitly in data fields
      if (!totalDays || !fromDate) {
        // Simple regex to find dates in DD-MM-YYYY or YYYY-MM-DD format
        const dateRegex = /(\d{2}-\d{2}-\d{4})|(\d{4}-\d{2}-\d{2})/g;
        const foundDates = errorMessage.match(dateRegex);
        if (foundDates) {
          if (!fromDate) fromDate = foundDates[0];
          if (!toDate) toDate = foundDates[foundDates.length - 1];
          if (!totalDays) totalDays = foundDates.length;
        }
      }

      // If we have an array of leaves, ensure from/to dates are set
      if (Array.isArray(pendingLeaves) && pendingLeaves.length > 0) {
        const first = pendingLeaves[0];
        const last = pendingLeaves[pendingLeaves.length - 1];
        if (!fromDate) fromDate = typeof first === 'string' ? first : first.date;
        if (!toDate) toDate = typeof last === 'string' ? last : last.date;
      }

      const showAddLeaveButton = errorMessage !== "You have already \"Clocked In\" today!! Please refresh the page.";
      const isPendingLeaveError = errorMessage.toLowerCase().includes("pending") || errorMessage.toLowerCase().includes("leave") || totalDays > 0;

      if (isPendingLeaveError && showAddLeaveButton) {
        // Fetch actual absent dates if they're missing from the error response
        if (!fromDate) {
          try {
            const today = new Date();
            let month = today.getMonth() + 1;
            let year = today.getFullYear();
            
            let attendanceRes = await Authapi.getAttendance(this.props.user.id, month, year);
            let absentDays = [];

            if (attendanceRes && attendanceRes.status && Array.isArray(attendanceRes.data)) {
              absentDays = attendanceRes.data.filter(day => day.status.toLowerCase() === 'absent');
            }

            // If no absent days this month, check last month too
            if (absentDays.length === 0) {
              month = month === 1 ? 12 : month - 1;
              year = month === 12 ? year - 1 : year;
              attendanceRes = await Authapi.getAttendance(this.props.user.id, month, year);
              if (attendanceRes && attendanceRes.status && Array.isArray(attendanceRes.data)) {
                absentDays = attendanceRes.data.filter(day => day.status.toLowerCase() === 'absent');
              }
            }

            if (absentDays.length > 0) {
              // Sort by date to get correct range
              absentDays.sort((a, b) => {
                const [da, ma, ya] = a.date.split('-').map(Number);
                const [db, mb, yb] = b.date.split('-').map(Number);
                return new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db);
              });

              fromDate = absentDays[0].date;
              toDate = absentDays[absentDays.length - 1].date;
              totalDays = absentDays.length;
            }
          } catch (fetchError) {
            console.error("Error fetching attendance for popup:", fetchError);
          }
        }

        const content = document.createElement("div");
        content.className = "pending-leave-container";
        content.innerHTML = `
          <p class="pending-leave-message">Add Your Pending Leave.</p>
          <div class="pending-leave-card">
            <table class="pending-leave-table">
              <tr>
                <td class="pending-leave-label">Total Day(s):</td>
                <td class="pending-leave-value">${totalDays || '1'} Day</td>
              </tr>
              <tr>
                <td class="pending-leave-label">From Date:</td>
                <td class="pending-leave-value">${fromDate || 'N/A'}</td>
              </tr>
              <tr>
                <td class="pending-leave-label">To Date:</td>
                <td class="pending-leave-value">${toDate || fromDate || 'N/A'}</td>
              </tr>
            </table>
          </div>
          <p class="pending-leave-footer">Please submit a leave request for the above period to start timer!</p>
        `;

        swal({
          title: "Remaining Leave Alert",
          content: content,
          className: "pending-leave-modal",
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              className: "swal-cancel-btn",
              closeModal: true
            },
            add: {
              text: "Add Leave",
              value: "add",
              visible: true,
              className: "swal-add-leave-btn",
              closeModal: true
            }
          }
        }).then((value) => {
          if (value === "add") {
            this.props.history.push({
              pathname: "/leave-tickets/add",
              state: {
                date: fromDate,
                endDate: toDate,
                type: "Loss Of Pay",
                message: "Pending Leave"
              }
            });
          } else {
            window.location.reload();
          }
        });
      } else {
        swal({
          title: "Error",
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "gray-button",
              closeModal: true
            },
            ...(showAddLeaveButton && {
              add: {
                text: "Add Leave",
                value: "add",
                visible: true,
                className: "swal-add-leave-btn",
                closeModal: true
              }
            })
          }
        }).then((value) => {
          if (value === "add") {
            this.props.history.push({
              pathname: "/leave-tickets/add",
              state: {
                type: "Loss Of Pay",
                message: "Pending Leave"
              }
            });
          } else {
            window.location.reload();
          }
        });
      }
    }
  };

  handlePause = async () => {
    this.setState({ isLoading: true });
    try {

      const monthlyData = await Authapi.getMonthlyWorkHours(this.props.user.id);

      if (
        monthlyData &&
        monthlyData.hasOwnProperty('workingHoursAlertEnabled') &&
        monthlyData.workingHoursAlertEnabled === false
      ) {
        await this.proceedWithCheckout();
        return;
      }

      if (monthlyData && monthlyData.status) {
        const totalDurationToday = monthlyData.totalDurationToday || 0;


        let isInDynamicWindow = false;
        if (Object.prototype.hasOwnProperty.call(monthlyData, 'isCurrentSessionSevenToEight')) {
          isInDynamicWindow = !!monthlyData.isCurrentSessionSevenToEight;
        } else if (
          monthlyData &&
          (monthlyData.targetFullDayHours !== undefined && monthlyData.targetUpperHours !== undefined) &&
          typeof totalDurationToday === 'number'
        ) {
          const lower = Number(monthlyData.targetFullDayHours) * 3600;
          const upper = Number(monthlyData.targetUpperHours) * 3600;
          isInDynamicWindow = totalDurationToday >= lower && totalDurationToday < upper;
        } else {
          isInDynamicWindow = totalDurationToday >= 25200 && totalDurationToday < 28800;
        }

        if (isInDynamicWindow) {
          this.setState({ isLoading: false });

          const result = await swal({
            title: "Working hours alert!",
            text: `You are within your working hours alert window. Would you like to proceed with checkout?`,
            icon: "warning",
            buttons: {
              stayIn: { text: "STAY IN", value: "stayIn", className: "swal-stay-in-btn" },
              stayOut: { text: "STAY OUT", value: "stayOut", className: "swal-stay-out-btn" }
            },
            dangerMode: true
          });
          if (result === "stayIn") return;
          else if (result === "stayOut") await this.proceedWithCheckout();
        } else {
          await this.proceedWithCheckout();
        }
      } else {

        await this.proceedWithCheckout();
      }
    } catch (error) {

      await this.proceedWithCheckout();
    }
  };

  proceedWithCheckout = async () => {

    await new Promise(resolve => setTimeout(resolve, 2000));

    try {
      await Authapi.outTime();
      this.setState({ isActive: false, stopTime: Date.now(), isLoading: false }, () => {
        workerTimers.clearInterval(this.countRef.current);
        workerTimers.clearInterval(this.totalCountRef.current);
        this.clearExtensionState();
        this.syncExtensionState({ isTimerActive: false });

        toast.error("You marked OUT", { autoClose: 1500 });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
    } catch (error) {
      this.setState({ isLoading: false });
      console.error("Error during checkout:", error);
    }
  };

  formatTime = () => {
    const { timer } = this.state;
    const getSeconds = `0${timer % 60}`.slice(-2);
    const minutes = Math.floor(timer / 60);
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);
    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  formatTime1 = () => {
    const { totaltimer } = this.state;
    const getSeconds = `0${totaltimer % 60}`.slice(-2);
    const minutes = Math.floor(totaltimer / 60);
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(totaltimer / 3600)}`.slice(-2);

    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  render() {
    if (this.state.isInitialLoading) {
      return <div className="stopwatch-card"><p className="timerText" style={{ marginLeft: "40px" }}>Loading...</p></div>;
    }

    return (


      <div className="stopwatch-card">
        <p className="timerText">{this.formatTime1()}</p>
        <p className="timerText" style={{ fontSize: "11px", marginTop: "-8px", opacity: 0.75 }}>
          Auto off via extension: {this.state.extensionConnected ? "Connected" : "Not connected"}
        </p>
        {!!this.state.extensionWarningMessage && (
          <p
            className="timerText"
            style={{
              fontSize: "11px",
              marginTop: "-4px",
              marginBottom: "8px",
              color: "#ff9800",
              lineHeight: 1.4,
            }}
          >
            {this.state.extensionWarningMessage}
          </p>
        )}
        <div className="extension-debug-panel">
          <strong className="extension-debug-title">
            Extension Debug {this.state.extensionDebugTime ? `(${this.state.extensionDebugTime})` : ""}
          </strong>
          <span>{this.state.extensionDebugStatus}</span>
        </div>
        <div className="buttons">
          {!this.state.isActive && (
            <PremiumButton
              onClickFn={this.handleStart}
              btnText="IN"
              loading={this.state.isLoading}
              disabled={this.state.isLoading}
            />
          )}
          {this.state.isActive && (
            <PremiumButton
              onClickFn={this.handlePause}
              btnText="OUT"
              loading={this.state.isLoading}
              disabled={this.state.isLoading}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Timer);
